/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import { Individu } from '@/types';

const validationInformationsComplementaires = (data: Partial<Individu> & { hasDoubleNationalite?: boolean }) => {
  const errors = {
    identifiantNationaliteBis: '',
    scolarise: '',
    activiteProfessionnelle: '',
  };

  if (data.hasDoubleNationalite && !data.identifiantNationaliteBis) {
    errors.identifiantNationaliteBis = 'Veuillez sélectionner une nationalité ou décocher la case.';
  }

  if (_.isNil(data.scolarise)) {
    errors.scolarise = 'Veuillez indiquer si la personne est scolarisée ou en formation.';
  }

  if (_.isNil(data.activiteProfessionnelle)) {
    errors.activiteProfessionnelle = 'Veuillez indiquer si la personne a une activité professionnelle.';
  }

  return _.pickBy(errors, (value) => value !== '');
};

export default validationInformationsComplementaires;



